import { Api, IApiResponse } from './Api';

export interface IApiKey {
    apiKey: string;
    apiName: string;
}

let apiResponse: IApiResponse = {
    data: null,
    error: false,
}

export const CredentialService = {
    getApiKeys: async () => {
        try {
            const response = await Api.get("/Authenticate/api-key");
            apiResponse.data = response.data;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    },

    requestApiKey: async () => {
        try {
            const response = await Api.post("/Authenticate/api-key",{});
            apiResponse.data = response.data;
        } catch (error) {
            apiResponse.data = error;
            apiResponse.error = true;
        }
        return apiResponse;
    }
}